import { JsonViewer } from '@textea/json-viewer'
import { Dispatch, FC, SetStateAction } from 'react'

import CloseIcon from '@mui/icons-material/Close'
import { Dialog, DialogContent, Box, Typography } from '@mui/material'

interface IProps {
  modal: boolean
  setModal: Dispatch<SetStateAction<boolean>>
  jsonData: any
}

const JsonViewModal: FC<IProps> = ({ jsonData, modal, setModal }) => {
  return (
    <Dialog
      open={modal}
      onClose={() => setModal(false)}
      fullWidth
      maxWidth="md"
      sx={{ maxHeight: 'calc(100vh - 100px)', margin: 'auto' }}
      slotProps={{
        paper: {
          sx: { borderRadius: '4px' },
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          p: '5px 10px 0 10px',
        }}
      >
        <Typography variant={'h6'}>JSON</Typography>
        <CloseIcon fontSize={'large'} sx={{ cursor: 'pointer' }} onClick={() => setModal(false)} />
      </Box>
      <DialogContent>
        <JsonViewer value={jsonData} />
      </DialogContent>
    </Dialog>
  )
}

export default JsonViewModal
